// extracted by mini-css-extract-plugin
module.exports = {"bg":"_1J_YO","scotchL":"_3sE-b","scotchR":"_3L1H8"};